import React, { Component } from 'react';
import intl from "react-intl-universal";
import { CircularProgress, Drawer } from "@material-ui/core";
import { withRouter } from 'react-router-dom';

class ProtectionTypeDrawer extends Component {
    constructor(props) {
        super(props);
    }


    handleSaveProtectionType = (previousProtectionTypeCodes, addedProtectionTypeCodes, productId, packageId, productName) => {
        let protectionTypeCodes = previousProtectionTypeCodes.length > 0 ? previousProtectionTypeCodes + "," + addedProtectionTypeCodes : addedProtectionTypeCodes.toString();
        fetch(process.env.REACT_APP_API_URL + "UpdateProtectionType", {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                productId: productId,
                packageId: packageId,
                productName: productName,
                protectionTypeCodes: protectionTypeCodes,
            }),
        })
            .then((res) => res.json())
            .then((result) => {
                if (result.success) {
                    if (result.data) {
                        this.props.handleSavedProtectionTypeCodes(result.data, this.props.productName);
                    }
                } else {
                    this.props.handleErrorSavedProtectionTypeCodes(result.error.message);
                }
            })
            .catch((error) => {
                this.props.handleErrorSavedProtectionTypeCodes(error.message);
            });
    };

    handleSaveClick = () => {
        try {
            this.props.handleErrorSavedProtectionTypeCodes("");

            const text = this.props.textAreaTexts;
            const txtlines = text.split(/[\n ,;]+/).filter((x) => x.trim() !== '');

            const invalidLines = [];

            for (const line of txtlines) {
                if (!(/^[a-zA-Z0-9]+$/).test(line.replace(/-|\s/g, ''))) {
                    invalidLines.push(line);
                }
            }

            if (invalidLines.length > 0) {
                // Return an error message with the list of invalid lines
                this.props.handleErrorSavedProtectionTypeCodes(`Line ${invalidLines.join(', ')} contain invalid characters.`);
                return;
            }

            var formattedLines = "";
            // Split and format the lines
            if (this.props.protectionType.toLowerCase() === "machinecode") {
                formattedLines = txtlines.map((line) => this.formattingMachineKey(line, 4));
            }
            else if (this.props.protectionType.toLowerCase() === "macaddress") {
                formattedLines = txtlines.map((line) => this.validateMACAddress(line));
            }

            console.log(this.props.errorProtectionTypeMessage);
            if (formattedLines.filter(x => x == undefined).length === 0) {
                this.handleSaveProtectionType(this.props.protectionTypeState, formattedLines, this.props.productId, this.props.packageId, this.props.productName);
            }
        }
        catch (err) {
            this.props.handleErrorSavedProtectionTypeCodes("Invalid code format. Codes must only contain letters, numbers, or hyphens.");
        }
    }

    formattingMachineKey = (line) => {
        // Remove any existing hyphens and whitespace
        line = line.replace(/-|\s/g, '');   // Remove '-' if exists

        if (line.length < 16 || line.length > 36 || line.length % 4 !== 0) {
            this.props.handleErrorSavedProtectionTypeCodes("Invalid code format. Codes must only contain letters, numbers, or hyphens.");
            return;
        }

        const parts = [];
        for (let i = 0; i < line.length; i += 4) {
            const part = line.substr(i, 4);
            parts.push(part);
        }

        if (parts.length < 4) {
            this.props.handleErrorSavedProtectionTypeCodes('Error: Line must contain at least 4 parts.');
            return;
        }

        const formattedLine = parts.join('-');
        return formattedLine;
    }

    validateMACAddress = (macAddress) => {
        // Remove any existing colons, hyphens, and whitespace
        macAddress = macAddress.replace(/[:-\s]/g, '');


        // Regular expression to match a valid MAC address format
        const macRegex = /^([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})([0-9A-Fa-f]{2})$/;

        if (!macRegex.test(macAddress)) {
            this.props.handleErrorSavedProtectionTypeCodes('Invalid MAC address format. Please provide a valid MAC address.');
            return;
        }

        const formattedMAC = macAddress.match(/.{1,2}/g).join(':');
        return formattedMAC;

    }

    render() {
        return (
            <Drawer className='protectionTypeDrawer' anchor="right" open={this.props.openDrawer} onClose={() => this.props.toggleDrawer(false, "")}>
                <div className="drawerDivClass">
                    <h3 className='hTitleDrawer'>{this.props.protectionType && this.props.protectionType.toLowerCase() === "machinecode" ? intl.get("MachineCodes_Title")
                        : this.props.protectionType && this.props.protectionType.toLowerCase() === "macaddress" ? intl.get("MacAddresses_Title")
                            : intl.get("UsbKeys_Title")}
                    </h3>
                    {this.props.isDrawerLoading ? (
                        <CircularProgress size={60} className='drawerLoadingCircular' />
                    ) :
                        <div>
                            {this.props.readOnlyTextArea && this.props.readOnlyTextArea.length >= 0 ?
                                <div>
                                    <h5 className="subTitleDrawer">
                                        {this.props.protectionType.toLowerCase() === "machinecode" ? intl.get("AddedMachineCodes_SubTitle", { numOfProtectionTypes: this.props.numOfProtectionTypes })
                                            : this.props.protectionType.toLowerCase() === "macaddress" ? intl.get("AddedMacAddresses_SubTitle", { numOfProtectionTypes: this.props.numOfProtectionTypes })
                                                : intl.get("AddedUSBKeys_SubTitle", { numOfProtectionTypes: this.props.numOfProtectionTypes })}
                                    </h5>
                                    <div className="drawerMachineCodeDiv drawerAddedMachineCodes">
                                        <textarea
                                            rows="5" // Adjust the number of rows as needed
                                            className="draweMachineCodeInput show drawerAddedMachineCodesTextArea"
                                            readOnly
                                            value={this.props.readOnlyTextArea}
                                        />
                                    </div>
                                </div> : null}

                            {this.props.isTrustedCustomer ?
                                <>
                                    <h5 className="subTitleDrawer">
                                        {this.props.protectionType && this.props.protectionType.toLowerCase() === "machinecode" ? intl.get("MachineCodes_SubTitle") + (this.props.readOnlyTextArea.length <= 0 ? " (" + this.props.numOfProtectionTypes + ")" : "")
                                            : this.props.protectionType && this.props.protectionType.toLowerCase() === "macaddress" ? intl.get("MacAddresses_SubTitle") + (this.props.readOnlyTextArea.length <= 0 ? " (" + this.props.numOfProtectionTypes + ")" : "")
                                                : intl.get("USBKeys_SubTitle") + (this.props.readOnlyTextArea.length <= 0 ? " (" + this.props.numOfProtectionTypes + ")" : "")}
                                    </h5>
                                    <span className="addListDescription">
                                        {this.props.protectionType && this.props.protectionType.toLowerCase() === "machinecode" ? intl.get("MachineCodes_Description")
                                            : this.props.protectionType && this.props.protectionType.toLowerCase() === "macaddress" ? intl.get("MacAddress_Description")
                                                : intl.get("USBKeys_Description")}
                                    </span>

                                    <div className={`notification ${this.props.showSavedProtectionType ? 'show' : ''}`} style={{ left: '275px', top: '22%' }}>
                                        {this.props.protectionType && this.props.protectionType.toLowerCase() === "macaddress" ? intl.get("MAC_Address_Saved") : intl.get("Protection_Codes_Saved")}
                                    </div>
                                    <div className="drawerMachineCodeDiv">
                                        <textarea
                                            rows="5" // Adjust the number of rows as needed
                                            className={`draweMachineCodeInput`}
                                            value={this.props.textAreaTexts}
                                            onChange={this.props.handleChangeMachineCodeInput}
                                        />
                                        <div className="drawerAddMachineCodesListButtons">
                                            <button className="drawerMachineCodesButtons" onClick={this.props.handleClearClick}>Clear</button>
                                            <button className="drawerMachineCodesButtons drawerSaveButton" onClick={this.handleSaveClick}>Save</button>
                                        </div>
                                    </div>
                                </>
                                : null}
                            {
                                this.props.errorProtectionTypeMessage !== "" ?
                                    <div className="errorMessage">* {this.props.errorProtectionTypeMessage}</div> : null

                            }

                            {this.props.protectionType && this.props.protectionType.toLowerCase() === "machinecode" ?
                                <div className='mt-5'>
                                    <h5 className="subTitleDrawer">
                                        {intl.get("Registration_Instructions")}
                                    </h5>
                                    <ul>
                                        <li><b>Download Tool:</b> Click the link to download the <a href="https://cloud.skylineglobe.com/SGCloud/Downloads/LicenseRegistration.zip">Skyline License Registration tool.</a></li>
                                        <li><b>Extract and Run:</b> Unzip the exe file and execute 'LicenseRegistration.exe'.</li>
                                        <li><b>Copy Machine Code:</b> On each machine you want to add to the license, run the 'LicenseRegistration.exe' tool, copy the machine code displayed.</li>
                                        {this.props.isTrustedCustomer ?
                                            <>
                                                <li><b>Paste Here:</b> Paste the copied code into the list box on this page.</li>
                                                <li><b>Registration:</b> Save to add the machine code to your license</li>
                                            </>
                                            : <li><b>Submit Collected Machine Codes for Registration:</b> After gathering the machine codes from each device, send an email containing all the collected machine codes to <a href='mailto:licenses@skylinesoft.com'>Licenses@skylinesoft.com</a> to complete the registration process.</li>}
                                    </ul>
                                </div> :
                                this.props.protectionType && this.props.protectionType.toLowerCase() === "macaddress" ?
                                    <div className='mt-5'>
                                        <h5 className="subTitleDrawer">
                                            {intl.get("Registration_Instructions")}
                                        </h5>
                                        <ul>
                                            <li><b>Download Tool:</b> Click the link to download the <a href="https://cloud.skylineglobe.com/SGCloud/Downloads/LicenseRegistrationMac.zip">Skyline License Registration tool.</a></li>
                                            <li><b>Extract and Run:</b> Unzip the exe file and execute 'LicenseRegistration.exe'.</li>
                                            <li><b>Copy Mac Address:</b> From the 'LicenseRegistration.exe' tool, copy the mac address displayed.</li>
                                            <li><b>Paste Here:</b> Paste the copied code into the list box on this page.</li>
                                            <li><b>Registration:</b> Save to add the mac address to your license</li>
                                        </ul>
                                    </div> :
                                    null}
                        </div>
                    }
                </div>

                <div className="drawerCloseButtton">
                    {this.props.toggleDrawerFromURL ?
                        <button className="btn btn-outline-primary" onClick={() => { this.props.history.goBack(); }}>{intl.get("Drawer_Go_To_GettingStarted")}</button>
                        : null}
                    <button className="btn-primary ml-4 btn btn-default" onClick={() => { this.props.toggleDrawer(false, ""); }}>{intl.get("Drawer_Close_Button")}</button>
                </div>
            </Drawer>
        );
    }
}

export default withRouter(ProtectionTypeDrawer);